export default __webpack_public_path__ + "static/media/sweet_potatoe.cf251902.png";